import { toolInput } from "../tool-input";

/** How a git label names what the call targets, read defensively from its input. */
export const gitTarget = {
  pullRequest: (value: unknown): string | null =>
    typeof value === "number" && Number.isInteger(value) && value > 0
      ? `PR #${value}`
      : null,
  onPullRequest: (value: unknown): string =>
    `on ${gitTarget.pullRequest(value) ?? "a pull request"}`,
  named: (value: unknown): string | null => {
    const text = toolInput.trimmed(value);
    return text ? toolInput.truncate(text, 60) : null;
  },
  quoted: (value: unknown): string | null => {
    const text = toolInput.trimmed(value)?.split("\n")[0]?.trim();
    return text ? `"${toolInput.truncate(text, 60)}"` : null;
  },
};
